module.exports = __webpack_public_path__ + "images/sgp/5x5/50-things-fit-in-5x10.webp";